import { handleActions } from 'redux-actions'
import types from '../actions/types'

export const defaultState = {}

export default handleActions({
	[types.POLL_UPDATED]: (state, { payload }) => {
		if (payload.poll) {
			return {
				...state,
				[payload.pollId]: payload.poll,
			}
		}
		const newState = { ...state }
		delete newState[payload.pollId]
		return newState
	},
}, defaultState)



// WEBPACK FOOTER //
// ./src/redux/reducers/polls.js